import { cn } from './internal/utils'
import { RADIUS, STATUS_CLASSES, isPresetColor, resolvePresetStyle } from './internal/presets'

const CheckableTag = ({ checked, onChange, className, children, ...rest }) => (
  <button
    type="button"
    aria-pressed={checked}
    onClick={() => onChange?.(!checked)}
    className={cn(
      'ui-tag ui-tag-checkable inline-flex items-center border px-2 py-0.5 text-xs font-medium',
      RADIUS,
      checked
        ? 'ui-tag-checkable-checked border-[var(--primary-color)] bg-[var(--primary-color)] text-[var(--on-primary)]'
        : 'border-[var(--border-color)] bg-transparent text-[var(--text-body)] hover:text-[var(--primary-color)]',
      className
    )}
    {...rest}
  >
    {children}
  </button>
)

/**
 * antd Tag. Handles preset color names, arbitrary colors, the status colors and
 * `closable` with `onClose`.
 */
const Tag = ({
  color,
  closable = false,
  closeIcon,
  onClose,
  bordered = true,
  icon,
  className,
  style,
  children,
  ...rest
}) => {
  const isStatus = color && Object.hasOwn(STATUS_CLASSES, color) && !isPresetColor(color)
  const presetStyle = isStatus ? null : resolvePresetStyle(color)

  const handleClose = (event) => {
    event.stopPropagation()
    onClose?.(event)
  }

  return (
    <span
      className={cn(
        'ui-tag inline-flex max-w-full items-center gap-1 px-2 py-0.5 text-xs font-medium leading-5',
        RADIUS,
        bordered ? 'border' : 'border-0',
        isStatus && STATUS_CLASSES[color],
        !color && 'border-[var(--border-color)] bg-[var(--gray-100)] text-[var(--text-body)]',
        className
      )}
      style={{ ...presetStyle, ...style }}
      {...rest}
    >
      {icon}
      <span className="min-w-0 truncate">{children}</span>
      {closable ? (
        <button
          type="button"
          aria-label="Fermer"
          onClick={handleClose}
          className="ui-tag-close-icon -mr-0.5 inline-flex h-4 w-4 items-center justify-center rounded-full leading-none opacity-60 hover:opacity-100"
        >
          {closeIcon ?? <span aria-hidden="true">&times;</span>}
        </button>
      ) : null}
    </span>
  )
}

Tag.CheckableTag = CheckableTag

export default Tag
